import { Autocomplete, MenuItem } from "@mui/material"

import classNames from "classnames"
import CustomInput from "../CustomInput2"

const MultiSearchAndSelect = ({
  options,
  label,
  setValue,
  placeholder,
  className,
  inputClassName,
  loading,
  formik,
  name,
  setSearchValue,
  value = []
}) => {
  const handleChange = (_, val) => {
    if (formik) {
      formik.setFieldValue(name, val)
    } else {
      setValue(val)
    }
  }

  return (
    <Autocomplete
      multiple
      options={options}
      id="multiselect_values"
      loading={loading}
      onChange={handleChange}
      value={formik ? formik.values[name] : value}
      className={className}
      getOptionLabel={(option) => option.label}
      renderInput={(params) => (
        <CustomInput
          className={classNames(inputClassName, "!p-2 multi-search-and-select")}
          {...params}
          variant="standard"
          onChange={(e) => {
            setSearchValue(e.target.value)
          }}
          label={label}
          placeholder={placeholder}
        />
      )}
      renderOption={(props, option, { selected }) => (
        <MenuItem
          {...props}
          key={option}
          value={option}
          className={selected && "!bg-gray-300 !my-1"}
          sx={{ justifyContent: "space-between" }}
        >
          {option.label}
        </MenuItem>
      )}
    />
  )
}

export default MultiSearchAndSelect
